'use strict';

var promisify = require('promisify-es6');

var isIpfs = require('is-ipfs');

var setImmediate = require('async/setImmediate');

var doUntil = require('async/doUntil');

var CID = require('cids');

module.exports = function (self) {
  return promisify(function (name, opts, cb) {
    if (typeof opts === 'function') {
      cb = opts;
      opts = {};
    }

    opts = opts || {};

    if (!isIpfs.path(name)) {
      return setImmediate(function () {
        return cb(new Error('invalid argument'));
      });
    } // TODO remove this and update subsequent code when IPNS is implemented


    if (!isIpfs.ipfsPath(name)) {
      return setImmediate(function () {
        return cb(new Error('resolve non-IPFS names is not implemented'));
      });
    }

    var split = name.split('/'); // ['', 'ipfs', 'hash', ...path]

    var cid = new CID(split[2]);

    if (split.length === 3) {
      return setImmediate(function () {
        return cb(null, name);
      });
    }

    var path = split.slice(3).join('/');
    resolve(cid, path, function (err, cid) {
      if (err) return cb(err);
      if (!cid) return cb(new Error('found non-link at given path'));
      cb(null, "/ipfs/".concat(cid.toBaseEncodedString(opts.cidBase)));
    });
  }); // Resolve the given CID + path to a CID.

  function resolve(cid, path, callback) {
    var value;
    doUntil(function (cb) {
      self.block.get(cid, function (err, block) {
        if (err) return cb(err);
        var r = self._ipld.resolvers[cid.codec];

        if (!r) {
          return cb(new Error("No resolver found for codec \"".concat(cid.codec, "\"")));
        }

        r.resolver.resolve(block.data, path, function (err, result) {
          if (err) return cb(err);
          value = result.value;
          path = result.remainderPath;
          cb();
        });
      });
    }, function () {
      var endReached = !path || path === '/';

      if (endReached) {
        return true;
      }

      if (value) {
        cid = new CID(value['/']);
      }

      return false;
    }, function (err) {
      if (err) return callback(err);
      if (value && value['/']) return callback(null, new CID(value['/']));
      callback();
    });
  }
};